import { render, staticRenderFns } from "./KETRabattliste.vue?vue&type=template&id=82b176a0&"
import script from "./KETRabattliste.vue?vue&type=script&lang=js&"
export * from "./KETRabattliste.vue?vue&type=script&lang=js&"
import style0 from "./KETRabattliste.vue?vue&type=style&index=0&id=82b176a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports